import { useIntl } from 'react-intl';
import { UncontrolledTooltip } from 'reactstrap';
import { ArrowLeft, Expand, Settings, Star } from 'lucide-react';
import history from 'src/history';
import Button from 'src/componentes/button';
import { useEffect, useState } from 'react';
import http from 'src/services/httpService';
import ReactGA from 'react-ga4';
import { useSelector } from 'react-redux';
import RenomearFiltro from 'src/paginas/filtrofavorito/Renomear';
import ContentManager from 'src/componentes/content-manager';
import { useSnackbar } from 'notistack';
import CriticalConfirm from 'src/componentes/message-box/critical-confirm';
import { capitalizeFirstLetter } from 'src/utils/string';
import errorHandler from 'src/utils/error-handler';

const ButtonIcon = ({ children }) => (
  <span
    className="d-inline-flex align-items-center justify-content-center"
    style={{
      height: 24,
      lineHeight: 0,
      verticalAlign: 'middle',
      width: 20,
    }}
  >
    {children}
  </span>
);

const Content = ({
  titulo,
  isEllipsis = false,
  children,
  iconSettings = false,
  titleSettings = null,
  urlSettings = '',
  endPointPermissionSettings = null,
  actionsTop = null,
  iconFullScreen = false,
  handleFullScreen = null,
  showBackButton = true,
  handleClickSettings = null,
  handleClickBack = null,
  iconFavorite = false,
  filtroFavorito = {},
  showBorderBottom = true,
  ...rest
}) => {
  const id = 'PAGE-TITLE';
  const intl = useIntl();
  const user = useSelector((state) => state.user);
  const [hasAccessSettings, setHasAccessSettings] = useState(
    endPointPermissionSettings == null
  );
  const { enqueueSnackbar } = useSnackbar();

  const [ehFavorito, setEhFavorito] = useState(
    filtroFavorito?.ehFavorito ?? false
  );

  useEffect(() => {
    setEhFavorito(filtroFavorito?.ehFavorito ?? false);
  }, [filtroFavorito?.ehFavorito, filtroFavorito?.id]);

  const atualizarFavorito = () => {
    setEhFavorito((prev) => !prev);
  };

  const favoritarFiltro = () => {
    const url = `/FiltroColaborador/${filtroFavorito.tipoFiltro}/AtualizarNome`;
    ContentManager.addContent(
      <RenomearFiltro
        id={filtroFavorito.id}
        nome={''}
        url={url}
        isNew={true}
        updateCallback={atualizarFavorito}
      />
    );
  };

  const desfavoritar = async () => {
    try {
      const url = `/FiltroColaborador/${filtroFavorito.tipoFiltro}/DesfavoritarFavorito`;
      const response = await http.post(url, {
        filtroFavoritoId: filtroFavorito.id,
      });

      if (response) {
        atualizarFavorito();

        enqueueSnackbar(
          intl.formatMessage({ id: 'label.registroSalvoComSucesso' }),
          {
            variant: 'success',
            autoHideDuration: 3000,
          }
        );
      }
    } catch (err) {
      errorHandler(err);
    }
  };

  const desfavoritarFiltro = () => {
    ContentManager.addContent(
      <CriticalConfirm
        title={`${intl.formatMessage({
          id: 'excluir',
        })} ${intl.formatMessage({
          id: 'favorito',
        })}`}
        message={capitalizeFirstLetter(
          intl.formatMessage({ id: 'temCertezaExcluir' })
        )}
        handleConfirm={() => desfavoritar()}
        labelConfirm={intl.formatMessage({
          id: 'label.confirmarExclusao',
        })}
      />
    );
  };

  const onClickSettings = () => {
    const textoGA = titleSettings ?? `Configurações ${titulo}`;
    ReactGA.event(`${textoGA}`, {
      category: 'configuracao',
      action: textoGA,
      label: user?.nome,
    });

    if (urlSettings) history.push(urlSettings);
    else if (handleClickSettings) handleClickSettings();
  };

  const onClickBack = () => {
    if (handleClickBack) handleClickBack();
    else history.goBack();
  };

  const onClickFullScreen = () => {
    if (handleFullScreen) handleFullScreen();
  };

  const [canGoBack, setCanGoBack] = useState(history.length > 1);

  useEffect(() => {
    if (iconSettings && endPointPermissionSettings) {
      http.post(endPointPermissionSettings).then((response) => {
        setHasAccessSettings(response.data);
      });
    }
  }, [endPointPermissionSettings]);

  useEffect(() => {
    const unsubscribe = history.listen(({ action }) => {
      if (action === 'POP') {
        setCanGoBack(history.length > 1);
      }
    });
    return unsubscribe;
  }, []);
  return (
    <div className="no-style  p-4" {...rest}>
      {titulo && (
        <>
          <h3
            className={`mb-4 pb-md-2 ignoreInPrint ${
              isEllipsis ? 'text-truncate' : ''
            }`}
            style={
              showBorderBottom ? { borderBottom: '1px solid #e4eaec' } : {}
            }
          >
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                {showBackButton && canGoBack && (
                  <div
                    className="text-primary cursor-pointer mr-2"
                    style={{ marginTop: '-2px' }}
                  >
                    <ArrowLeft size={22} onClick={onClickBack} />
                  </div>
                )}
                <span id={id}>{titulo}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {iconFavorite && filtroFavorito && filtroFavorito.id != 0 && (
                  <div style={{ marginRight: '8px' }}>
                    <Star
                      key={ehFavorito ? 'star-on' : 'star-off'}
                      className="text-primary"
                      fill={ehFavorito ? 'currentColor' : 'none'}
                      size={19}
                      style={{ fontSize: '24px', cursor: 'pointer' }}
                      onClick={() => {
                        if (!ehFavorito) {
                          favoritarFiltro();
                        } else {
                          desfavoritarFiltro();
                        }
                      }}
                    />
                  </div>
                )}
                {hasAccessSettings && iconSettings && (
                  <div id={'tooltipSettings'} style={{ marginRight: '8px' }}>
                    <Settings
                      className="text-primary"
                      size={19}
                      onClick={onClickSettings}
                      style={{ cursor: 'pointer' }}
                    />
                    {titleSettings && (
                      <UncontrolledTooltip
                        target={'tooltipSettings'}
                        placement="auto"
                      >
                        {titleSettings}
                      </UncontrolledTooltip>
                    )}
                  </div>
                )}
                {iconFullScreen && (
                  <div id={'tooltipFullScreen'} style={{ marginRight: '8px' }}>
                    <Button
                      id="matriz-fullscreen"
                      className="mr-2"
                      onClick={() => onClickFullScreen()}
                    >
                      <ButtonIcon>
                        <Expand size={16} />
                      </ButtonIcon>
                    </Button>
                    <UncontrolledTooltip target="matriz-fullscreen">
                      {intl.formatMessage({ id: 'telaCheia' })}
                    </UncontrolledTooltip>
                  </div>
                )}
                {actionsTop && <>{actionsTop}</>}
              </div>
            </div>
          </h3>
          {isEllipsis && (
            <UncontrolledTooltip target={id} placement="auto">
              {titulo}
            </UncontrolledTooltip>
          )}
        </>
      )}
      {children}
    </div>
  );
};

export default Content;
